export const TimePickerHook = {
  element: null,
  popup: null,
  outsideClickRef: null,
  hourInput: null,
  minuteInput: null,
  hourUpButton: null,
  hourDownButton: null,
  minuteUpButton: null,
  minuteDownButton: null,
  hour: null,
  minute: null,
  bind_change: true,

  mounted() {
    this.element = this.el;
    this.popup = $(this.element).next();

    const timeInputs = $(".time-picker", this.popup);
    this.hourInput = timeInputs[0];
    this.minuteInput = timeInputs[1];

    this.hourUpButton = $(".hour-up", this.popup)[0];
    this.hourDownButton = $(".hour-down", this.popup)[0];
    this.minuteUpButton = $(".minute-up", this.popup)[0];
    this.minuteDownButton = $(".minute-down", this.popup)[0];

    this.element.addEventListener("click", async () => {
      if (this.hour == null) {
        const [hour, minute] = this.get_hr_min_rounded(
          Number.parseInt(this.hourInput.querySelector("input").value, 10),
          Number.parseInt(this.minuteInput.querySelector("input").value, 10),
        );
        this.hour = hour;
        this.minute = minute;

        this.bind_change = false;
        this.select_tag_value(
          this.hour.toString().padStart(2, "0"),
          this.minute.toString().padStart(2, "0"),
        );
        this.bind_change = true;

        // otherwise the first click doesn't show the widget
        await new Promise((r) => setTimeout(r, 100));
      }

      // If outsideClick is already set don't rebind it
      if (!this.outsideClickRef) {
        this.outsideClickRef = this.outsideClick.bind(this);
        window.addEventListener("click", this.outsideClickRef);
      }
      this.popup.toggleClass("hidden");
    });

    this.hourInput.addEventListener("change", (event) => {
      if (this.bind_change) {
        this.changeHour(event.target.value);
      }
    });

    this.minuteInput.addEventListener("change", (event) => {
      if (this.bind_change) {
        this.changeMinute(event.target.value);
      }
    });

    this.hourUpButton.addEventListener("click", (event) => {
      this.changeHour(this.hour + 1);
      this.element.dispatchEvent(new Event("blur"));
    });

    this.hourDownButton.addEventListener("click", (event) => {
      this.changeHour(this.hour - 1);
      this.element.dispatchEvent(new Event("blur"));
    });

    this.minuteUpButton.addEventListener("click", (event) => {
      if (this.minute === 60) {
        this.changeHour(this.hour + 1);
        this.changeMinute(5);
      } else {
        // take closest 5 multiple
        const minute = Math.round((this.minute + 5) / 5) * 5;
        if (minute >= 60) {
          this.changeHour(this.hour + 1);
          this.changeMinute(0);
        } else {
          this.changeMinute(minute);
        }
      }
      this.element.dispatchEvent(new Event("blur"));
    });

    this.minuteDownButton.addEventListener("click", (event) => {
      if (this.minute === 0) {
        this.changeHour(this.hour - 1);
        this.changeMinute(55);
      } else {
        // take closest 5 multiple
        const minute = Math.round((this.minute - 5) / 5) * 5;
        this.changeMinute(minute);
      }
      this.element.dispatchEvent(new Event("blur"));
    });

    // convenience function to improve direct user entry into the input field
    this.element.addEventListener("blur", (_event) => {
      const hms = this.element.value.split(":");

      this.bind_change = false;
      switch (hms.length) {
        case 1: {
          const hr = Number.parseInt(hms[0], 10);
          this.hour = hr;
          this.minute = 0;
          this.format_value(this.hour, this.minute);
          this.select_tag_value(hms[0].padStart(2, "0"), "00");
          break;
        }
        case 2: {
          const hr = Number.parseInt(hms[0], 10);
          const mn = Number.parseInt(hms[1], 10);
          this.hour = hr;
          this.minute = mn;
          this.format_value(this.hour, this.minute);
          this.select_tag_value(hms[0].padStart(2, "0"), hms[1].padStart(2, "0"));
          break;
        }
        case 3: {
          const hr = Number.parseInt(hms[0], 10);
          const mn = Number.parseInt(hms[1], 10);
          const sec = Number.parseInt(hms[2], 10);
          this.hour = hr;
          if (sec === 59) {
            this.minute = mn + 1;
          }
          if (this.minute === 60 && sec >= 59) {
            this.minute = 0;
            this.hour = this.hour + 1;
          }

          this.format_value(this.hour, this.minute);
          this.select_tag_value(`${this.hour}`.padStart(2, "0"), `${this.minute}`.padStart(2, "0"));
          break;
        }
      }
      this.bind_change = true;
    });

    // don't submit the form when pressing enter but focus on the next element instead
    this.element.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        this.focusNextElement();
        event.preventDefault();
        return false;
      }
    });
  },

  outsideClick(event) {
    if (event.target === this.element || $(event.target).closest(".popup").length) {
      return;
    }

    this.hidePopup();
  },

  hidePopup() {
    window.removeEventListener("click", this.outsideClickRef);
    this.outsideClickRef = null;
    this.popup.addClass("hidden");
  },

  changeHour(new_hour) {
    this.hour = Number.parseInt(new_hour, 10);
    const seconds = this.element.getAttribute("seconds");
    const minute = seconds !== "" && seconds != null && this.minute === 59 ? 60 : this.minute;
    this.format_value(this.hour, minute);
  },

  changeMinute(new_minute) {
    this.minute = Number.parseInt(new_minute, 10);
    this.format_value(this.hour, this.minute);
  },

  format_value(hour, minute) {
    const [hr_str, mn_str] = this.format_hr_min(hour, minute);
    const seconds = this.element.getAttribute("seconds");

    if (seconds === "" || seconds == null) {
      this.element.value = `${hr_str}:${mn_str}`;
    } else {
      this.element.value = `${hr_str}:${mn_str}:${seconds}`;
    }
  },

  format_hr_min(hour, minute) {
    let new_hour = hour;
    let new_minute = minute;
    if (this.element.getAttribute("seconds") === "59") {
      if (new_minute === 0) {
        new_hour = new_hour - 1;
      }
      if (new_hour < 0 || new_hour > 23) {
        new_hour = 23;
      }
      new_minute = new_minute - 1;
      if (new_minute < 0 || new_minute > 59) {
        new_minute = 59;
      }
    } else {
      if (new_hour < 0 || new_hour > 23) {
        new_hour = 0;
      }
      if (new_minute < 0 || new_minute > 59) {
        new_minute = 0;
      }
    }
    return [new_hour.toString().padStart(2, "0"), new_minute.toString().padStart(2, "0")];
  },

  get_hr_min_rounded(hour, minute) {
    let new_hour = hour;
    let new_minute = minute;
    if (this.element.getAttribute("seconds") === "59") {
      if (new_minute === 59) {
        new_hour = new_hour + 1;
      }
      if (new_hour < 0 || new_hour > 23) {
        new_hour = 0;
      }
      new_minute = new_minute + 1;
      if (new_minute < 0 || new_minute > 59) {
        new_minute = 0;
      }
    }
    return [new_hour, new_minute];
  },

  select_tag_value(hour, minute) {
    const h_input = this.hourInput.querySelector("input");
    const m_input = this.minuteInput.querySelector("input");
    // to force a selection even if the hour & minute are identicals
    if (hour !== "00") {
      h_input.tagify.selectTag(h_input, { id: "00", value: "00" });
    } else {
      h_input.tagify.selectTag(h_input, { id: "01", value: "01" });
    }
    h_input.tagify.selectTag(h_input, { id: hour, value: hour });
    m_input.tagify.selectTag(m_input, { id: minute, value: minute });
  },

  focusNextElement() {
    const focussableElements =
      'a:not([disabled]), button:not([disabled]), input:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
    if (document.activeElement?.form) {
      const focussable = Array.prototype.filter.call(
        document.activeElement.form.querySelectorAll(focussableElements),
        (element) => {
          // check for visibility while always include the current activeElement
          return (
            element.offsetWidth > 0 ||
            element.offsetHeight > 0 ||
            element === document.activeElement
          );
        },
      );
      const index = focussable.indexOf(document.activeElement);
      if (index > -1) {
        const nextElement = focussable[index + 1] || focussable[0];
        nextElement.focus();
      }
    }
  },
};
